export const UMB_MEMBER_GROUP_COLLECTION_ALIAS = 'Umb.Collection.MemberGroup';
export * from './repository/constants.js';
export * from './views/constants.js';
